module.exports = __webpack_public_path__ + "media/application/images/svgs/icons/x-bf2d341f8f0c5709456c9e1a4497a461.svg";